import { Button } from "@/components/ui/button";
import { FileText } from 'lucide-react';
import { useDataProvider, useNotify, useRecordContext } from 'ra-core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import type { Project } from '../types';

export const CreateProjectQuotationButton = () => {
    const record = useRecordContext<Project>();
    const navigate = useNavigate();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [loading, setLoading] = useState(false);

    if (!record) return null;

    const handleCreate = async () => {
        setLoading(true);
        try {
            // Pre-fetch company name so customer_name is never null on save
            let customerName = '';
            if (record.company_id) {
                const { data: company } = await dataProvider.getOne('companies', { id: record.company_id });
                customerName = company?.name || '';
            }

            navigate('/quotations/create', {
                state: {
                    record: {
                        project_id: record.id,
                        company_id: record.company_id,
                        customer_id: record.contact_id,
                        customer_name: customerName,
                        status: 'draft',
                        items: [],
                        notes: `Quotation for Project: ${record.name} (${record.reference})`
                    }
                }
            });
        } catch {
            notify('Error loading company details', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            variant="outline"
            size="sm"
            onClick={handleCreate}
            disabled={loading}
            className="gap-2 text-blue-600 border-blue-200 hover:bg-blue-50"
        >
            <FileText className="w-4 h-4" />
            {loading ? 'Loading...' : 'Create Quotation'}
        </Button>
    );
};
